import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTModalCard = _resolveComponent("KTModalCard")!
  const _component_AddUserModal = _resolveComponent("AddUserModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_KTModalCard, {
      title: "Welcome!",
      description: "There are no users added yet. <br/>Kickstart your CRM by adding a your first user",
      image: "media/illustrations/sketchy-1/2.png",
      "button-text": "Add User",
      "modal-id": "kt_modal_add_user"
    }),
    _createVNode(_component_AddUserModal)
  ], 64))
}